import { useEffect, useState } from 'react';

import dayjs from 'dayjs';

export const useDailyLocalStorageReminderIsVisible = (
  key: string,
  delayMs: number,
  unit: 'day' | 'isoWeek' | 'month',
) => {
  const [isVisible, setIsVisible] = useState(false);
  const [shouldDisplayReminder, setShouldDisplayReminder] = useState(() => {
    const lastViewedAt = localStorage.getItem(key);
    if (lastViewedAt) {
      const wasViewedToday = dayjs().isSame(dayjs(lastViewedAt), unit);
      return !wasViewedToday;
    }

    return true;
  });

  useEffect(() => {
    if (shouldDisplayReminder) {
      const timeout = setTimeout(() => {
        setIsVisible(true);
      }, delayMs);

      return () => {
        clearTimeout(timeout);
      };
    }
  });

  const handleDailyLocalStorageReminderAcknowledged = () => {
    localStorage.setItem(key, dayjs().toISOString());
    setShouldDisplayReminder(false);
    setIsVisible(false);
  };

  return {
    isDailyLocalStorageReminderVisible: isVisible,
    handleDailyLocalStorageReminderAcknowledged,
  };
};
